"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _AccordionContext = _interopRequireDefault(require("../Accordion/AccordionContext"));
var _accordionSummaryClasses = _interopRequireWildcard(require("./accordionSummaryClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, expanded = ownerState.expanded, disabled = ownerState.disabled, disableGutters = ownerState.disableGutters;
    var slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, _composeClasses.default)(slots, _accordionSummaryClasses.getAccordionSummaryUtilityClass, classes);
};
var AccordionSummaryRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    var _obj;
    return _obj = {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition)
    }, _define_property(_obj, "&.".concat(_accordionSummaryClasses.default.focusVisible), {
        backgroundColor: (theme.vars || theme).palette.action.focus
    }), _define_property(_obj, "&.".concat(_accordionSummaryClasses.default.disabled), {
        opacity: (theme.vars || theme).palette.action.disabledOpacity
    }), _define_property(_obj, "&:hover:not(.".concat(_accordionSummaryClasses.default.disabled, ")"), {
        cursor: 'pointer'
    }), _define_property(_obj, "variants", [
        {
            props: function(props) {
                return !props.disableGutters;
            },
            style: _define_property({}, "&.".concat(_accordionSummaryClasses.default.expanded), {
                minHeight: 64
            })
        }
    ]), _obj;
}));
var AccordionSummaryContent = (0, _zeroStyled.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: function(props, styles) {
        return styles.content;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: function(props) {
                    return !props.disableGutters;
                },
                style: _define_property({
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    })
                }, "&.".concat(_accordionSummaryClasses.default.expanded), {
                    margin: '20px 0'
                })
            }
        ]
    };
}));
var AccordionSummaryExpandIconWrapper = (0, _zeroStyled.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: function(props, styles) {
        return styles.expandIconWrapper;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return _define_property({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        })
    }, "&.".concat(_accordionSummaryClasses.default.expanded), {
        transform: 'rotate(180deg)'
    });
}));
var AccordionSummary = /*#__PURE__*/ React.forwardRef(function AccordionSummary(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    var children = props.children, className = props.className, expandIcon = props.expandIcon, focusVisibleClassName = props.focusVisibleClassName, onClick = props.onClick, slots = props.slots, slotProps = props.slotProps, other = _object_without_properties(props, [
        "children",
        "className",
        "expandIcon",
        "focusVisibleClassName",
        "onClick",
        "slots",
        "slotProps"
    ]);
    var _React_useContext = React.useContext(_AccordionContext.default), _React_useContext_disabled = _React_useContext.disabled, disabled = _React_useContext_disabled === void 0 ? false : _React_useContext_disabled, disableGutters = _React_useContext.disableGutters, expanded = _React_useContext.expanded, toggle = _React_useContext.toggle;
    var handleChange = function(event) {
        if (toggle) {
            toggle(event);
        }
        if (onClick) {
            onClick(event);
        }
    };
    var ownerState = _object_spread_props(_object_spread({}, props), {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    var _ref = _sliced_to_array((0, _useSlot.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.root, className),
        elementType: AccordionSummaryRoot,
        externalForwardedProps: _object_spread({}, externalForwardedProps, other),
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: function(handlers) {
            return _object_spread_props(_object_spread({}, handlers), {
                onClick: function(event) {
                    var _handlers_onClick;
                    (_handlers_onClick = handlers.onClick) === null || _handlers_onClick === void 0 ? void 0 : _handlers_onClick.call(handlers, event);
                    handleChange(event);
                }
            });
        }
    }), 2), RootSlot = _ref[0], rootSlotProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('content', {
        className: classes.content,
        elementType: AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), ContentSlot = _ref1[0], contentSlotProps = _ref1[1];
    var _ref2 = _sliced_to_array((0, _useSlot.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), ExpandIconWrapperSlot = _ref2[0], expandIconWrapperSlotProps = _ref2[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentSlot, _object_spread_props(_object_spread({}, contentSlotProps), {
                children: children
            })),
            expandIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandIconWrapperSlot, _object_spread_props(_object_spread({}, expandIconWrapperSlotProps), {
                children: expandIcon
            }))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The icon to display as the expand indicator.
   */ expandIcon: _propTypes.default.node,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: _propTypes.default.string,
    /**
   * @ignore
   */ onClick: _propTypes.default.func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        content: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        expandIconWrapper: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        content: _propTypes.default.elementType,
        expandIconWrapper: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ])
} : void 0;
var _default = exports.default = AccordionSummary;
